<template>
  <div class="block__width-780">
     <div v-html="text">{{text}}</div>
  </div>
</template>


<script>
  export default {
    name: 'info',
    data () {
      return {
        text: ''
      }
    },
    props: {
      fetchData: {
        type: Object,
        default: function () {
          return []
        }
      }
    },
    mounted: function () {
      this.text = this.htmlDecode(this.fetchData['about']['text'])
    },
    methods: {
      htmlDecode: function (input) {
        /*eslint-disable */
        let str =  String(input).replace(/&amp;/g, "&")
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&quot;/g, '"')
          .replace(/&#039;/g, "'");
        let txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
        /*eslint-enable */
      }
    }
  }
</script>
<style>
    #section3{
      font-size: 18px;
      color: #ffffff;
      line-height: 1.33;
      text-align:left;
    }
    #section3 p{
      margin-bottom:0;
    }
    #section3 a{
      color:#50f7ab;
      text-decoration:none;
    }
    #section3 .project__title{
      font-size: 24px;
      font-weight: 600;
      line-height: 1;
      margin-bottom:30px;
    }
</style>



// WEBPACK FOOTER //
// Info.vue?92f36942